import request from '@/utils/request'

/** POST /api/v1/admin/data_statistics/home — 数据概览 */
export function getDataStatisticsHome(data) {
  return request({
    url: '/api/v1/admin/data_statistics/home',
    method: 'post',
    data,
    mock: false,
  })
}
